import { environment } from "@sharedenvironment";

export class OrganizationApiUrlUtil {
  /**
   * Format the API url route to send it to the Origanization micro service
   * @param apiRoute the api route without the extension
   * @returns the API route with the needed extension
   */
  public static formatApiUrl(apiRoute: string): string {
    return environment.organization.baseUrl + apiRoute;
  }
}